module.exports = "<template> <sio-color-palette config.bind=field value.bind=field.value></sio-color-palette> </template> ";